import { gql } from '@apollo/client';

import { TIME_ENTRY_RESPONSE } from '../../fragments/doctor';

export const GET_CLINICAL_USER_TIME_ENTRIES = gql`
  query GetClinicalUserTimeEntries {
    getMyTimeEntries {
      ...DoctorTimeEntryFragment
    }
  }
  ${TIME_ENTRY_RESPONSE}
`;
